
<div  class="card" style="padding: 20px; background-image: url('assets/img/school/bg.png');
 background-color: #005a63; background-size: 100px; background-attachment: fixed;">
 <h2 style=" text-align: center; margin-bottom: 10px;">E-Library</h2>
 <br ><br >
 <div class="container" style="text-align: justify !important;">
  <div class="row">
    <div  class="col-md-12">
      <div class="card">
        <div  class="card-body text-justify">
          <div  class="folder mb-3">
            <a  href="special-education">
              <i  aria-hidden="true" class="fa fa-folder">

              </i>
              <p >Special Education</p>
            </a>
          </div>
          <div  class="folder mb-3">
            <a  href="story">
              <i  aria-hidden="true" class="fa fa-folder"></i>
              <p >Story </p></a>
            </div>
            <div  class="folder mb-3">
                <a  href="rhymes">
                  <i aria-hidden="true" class="fa fa-folder"></i>
                  <p >Rhymes </p></a>
                </div>
                <div class="folder mb-3">
                    <a  href="science">
                      <i _ngcontent-vsw-c24="" aria-hidden="true" class="fa fa-folder">
                    </i>
                    <p >Science </p></a></div><div _ngcontent-vsw-c24="" class="folder mb-3">
                      <a  href="education">
                      <i aria-hidden="true" class="fa fa-folder"></i>
                      <p >Education </p></a>
                    </div>
                    <div  class="folder mb-3">
                      <a  href="independence-Of-bangladesh">
                        <i  aria-hidden="true" class="fa fa-folder"></i>
                        <p >Independence of Bangladesh  </p></a>
                      </div>
                      <div  class="folder mb-3">
                        <a  href="/medical-science">
                          <i  aria-hidden="true" class="fa fa-folder"></i>
                          <p >Medical Science  </p></a>
                        </div>
                        <div  class="folder mb-3">
                          <a  href="mathematic">
                            <i  aria-hidden="true" class="fa fa-folder"></i>
                            <p >Mathematics </p></a>
                          </div>
                          <div  class="folder mb-3">
                            <a  href="english">
                              <i  aria-hidden="true" class="fa fa-folder"></i>
                              <p >English</p></a>
                            </div>
                            <div  class="folder mb-3">
                              <a  href="e-history">
                                <i  aria-hidden="true" class="fa fa-folder"></i>
                                <p >History</p></a>
                              </div>
                              <div  class="folder mb-3">
                                <a  href="e-sports">
                                  <i  aria-hidden="true" class="fa fa-folder"></i>
                                  <p >Sports</p></a>
                                </div>
                                <div  class="folder mb-3">
                                  <a  href="e-personality">
                                    <i  aria-hidden="true" class="fa fa-folder"></i>
                                    <p >Personality</p></a>
                                  </div>
                                  <div  class="folder mb-3">
                                    <a  href="women-awakening">
                                      <i  aria-hidden="true" class="fa fa-folder"></i>
                                      <p >Women awakening </p></a>
                                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
